<template>
  <div class="data-analytics-page">
    <div class="content-container">
      <div class="content-section">
        <h1 class="main-heading animate-on-scroll">
          {{ $t("hp5.mainHeading") }}
        </h1>

        <p class="description animate-on-scroll">
          {{ $t("hp5.description1") }}<br />
        </p>

        <div class="features-grid">
          <div class="feature-item animate-on-scroll">
            <div class="feature-icon">
              <img src="@/assets/img/homePage/4-1.png" alt="benchmark icon" />
            </div>
            <span class="feature-text">{{ $t("hp5.features.benchmark") }}</span>
          </div>

          <div class="feature-item animate-on-scroll">
            <div class="feature-icon">
              <img src="@/assets/img/homePage/4-1.png" alt="measure icon" />
            </div>
            <span class="feature-text">{{ $t("hp5.features.measure") }}</span>
          </div>

          <div class="feature-item animate-on-scroll">
            <div class="feature-icon">
              <img src="@/assets/img/homePage/4-1.png" alt="understand icon" />
            </div>
            <span class="feature-text">{{
              $t("hp5.features.understand")
            }}</span>
          </div>

          <div class="feature-item animate-on-scroll">
            <div class="feature-icon">
              <img src="@/assets/img/homePage/4-1.png" alt="tailor icon" />
            </div>
            <span class="feature-text">{{ $t("hp5.features.tailor") }}</span>
          </div>
        </div>
      </div>

      <div class="background-section">
        <div class="server-racks"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    const isDesktop = window.matchMedia("(min-width: 769px)").matches
    const elements = this.$el.querySelectorAll(".animate-on-scroll")

    if (!isDesktop) {
      elements.forEach((el) => el.classList.add("is-visible"))
      return
    }

    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible")
            this._observer.unobserve(entry.target)
          }
        })
      },
      { root: null, threshold: 0.2 }
    )

    elements.forEach((el) => this._observer.observe(el))
  },
  beforeUnmount() {
    if (this._observer) this._observer.disconnect()
  },
}
</script>

<style scoped>
.data-analytics-page {
  min-height: 80vh;
  background: linear-gradient(135deg, #0a1929 0%, #1a365d 100%);
  position: relative;
  overflow: hidden;
  direction: ltr !important;
}

.content-container {
  position: relative;
  z-index: 2;
  display: flex;
  min-height: 100vh;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  direction: ltr !important;
}

.content-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4rem 0;
  max-width: 60%;
  position: relative;
  z-index: 3;
  text-align: left !important;
  direction: ltr !important;
}

@media (min-width: 769px) {
  .animate-on-scroll {
    opacity: 0;
    transform: translateY(24px);
    transition: opacity 600ms ease, transform 600ms ease;
    will-change: opacity, transform;
  }
  .animate-on-scroll.is-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .features-grid .feature-item:nth-child(1) {
    transition-delay: 80ms;
  }
  .features-grid .feature-item:nth-child(2) {
    transition-delay: 160ms;
  }
  .features-grid .feature-item:nth-child(3) {
    transition-delay: 240ms;
  }
  .features-grid .feature-item:nth-child(4) {
    transition-delay: 320ms;
  }
  .features-grid {
    margin-top: 60px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .animate-on-scroll,
  .animate-on-scroll.is-visible {
    transition: none;
    transform: none;
    opacity: 1;
  }
}

.main-heading {
  font-size: 40px;
  font-weight: bold;
  color: white;
  line-height: 1.2;
  margin-bottom: 2rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  text-align: left !important;
}

.description {
  font-size: 24px;
  color: white;
  line-height: 1.6;
  margin-bottom: 3rem;
  font-weight: 400;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  text-align: left !important;
}

.features-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  max-width: 600px;
  direction: ltr !important;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  text-align: left !important;
}

.feature-icon {
  width: auto;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
  margin-top: 0;
}
.feature-icon img {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: block;
}

.feature-text {
  color: white;
  font-size: 18px;
  line-height: 1.5;
  font-weight: 400;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  text-align: left !important;
}

.background-section {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 68%;
  z-index: 1;
  pointer-events: none;
}

.server-racks {
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
      to right,
      rgba(10, 25, 41, 0.85) 0%,
      rgba(10, 25, 41, 0.5) 40%,
      rgba(10, 25, 41, 0) 70%
    ),
    url("@/assets/img/homePage/3.png");
  background-size: cover;
  background-position: left center;
  background-repeat: no-repeat;
  -webkit-mask-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 8%,
    rgba(0, 0, 0, 0.8) 16%,
    rgba(0, 0, 0, 1) 24%,
    rgba(0, 0, 0, 1) 76%,
    rgba(0, 0, 0, 0.8) 84%,
    rgba(0, 0, 0, 0.4) 92%,
    rgba(0, 0, 0, 0) 100%
  );
  mask-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 8%,
    rgba(0, 0, 0, 0.8) 16%,
    rgba(0, 0, 0, 1) 24%,
    rgba(0, 0, 0, 1) 76%,
    rgba(0, 0, 0, 0.8) 84%,
    rgba(0, 0, 0, 0.4) 92%,
    rgba(0, 0, 0, 0) 100%
  );
}

/* RTL overrides */
[dir="rtl"] .data-analytics-page,
[dir="rtl"] .content-container,
[dir="rtl"] .content-section,
[dir="rtl"] .features-grid {
  direction: rtl !important;
}
[dir="rtl"] .content-section {
  text-align: right !important;
  margin-left: auto;
  margin-right: 0;
}
[dir="rtl"] .main-heading,
[dir="rtl"] .description,
[dir="rtl"] .feature-item {
  text-align: right !important;
  align-items: flex-end;
}
[dir="rtl"] .feature-text {
  text-align: right !important;
}
[dir="rtl"] .background-section {
  left: 0;
  right: auto;
}
[dir="rtl"] .server-racks {
  background-image: linear-gradient(
      to left,
      rgba(10, 25, 41, 0.85) 0%,
      rgba(10, 25, 41, 0.5) 40%,
      rgba(10, 25, 41, 0) 70%
    ),
    url("@/assets/img/homePage/3.png");
  background-position: right center;
  -webkit-mask-image: linear-gradient(
    to left,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 8%,
    rgba(0, 0, 0, 0.8) 16%,
    rgba(0, 0, 0, 1) 24%,
    rgba(0, 0, 0, 1) 76%,
    rgba(0, 0, 0, 0.8) 84%,
    rgba(0, 0, 0, 0.4) 92%,
    rgba(0, 0, 0, 0) 100%
  );
  mask-image: linear-gradient(
    to left,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 8%,
    rgba(0, 0, 0, 0.8) 16%,
    rgba(0, 0, 0, 1) 24%,
    rgba(0, 0, 0, 1) 76%,
    rgba(0, 0, 0, 0.8) 84%,
    rgba(0, 0, 0, 0.4) 92%,
    rgba(0, 0, 0, 0) 100%
  );
}

@media (max-width: 768px) {
  .data-analytics-page {
    min-height: 60vh;
  }

  .content-container {
    flex-direction: column;
    padding: 0 1rem;
    min-height: auto;
  }

  .content-section {
    max-width: 100%;
    padding: 1.5rem 0;
  }

  .main-heading {
    font-size: 2.8rem;
    margin-bottom: 1.5rem;
    line-height: 1.1;
  }

  .description {
    font-size: 1.3rem;
    margin-bottom: 2rem;
    line-height: 1.5;
  }

  .features-grid {
    grid-template-columns: 1fr;
    gap: 1.2rem;
  }

  .feature-text {
    font-size: 1.25rem;
    line-height: 1.4;
  }

  .background-section {
    position: static;
    width: 100%;
    height: 40px;
    min-height: auto;
    pointer-events: auto;
  }
}

@media (max-width: 480px) {
  .data-analytics-page {
    min-height: 50vh;
  }

  .content-section {
    padding: 1rem 0;
  }

  .main-heading {
    font-size: 2.4rem;
    margin-bottom: 1rem;
    line-height: 1.1;
  }

  .description {
    font-size: 1.2rem;
    margin-bottom: 1.5rem;
    line-height: 1.5;
  }

  .feature-text {
    font-size: 1.2rem;
    line-height: 1.4;
  }

  .background-section {
    position: static;
    width: 100%;
    height: 30px;
    min-height: auto;
    pointer-events: auto;
  }
}

@media (max-width: 360px) {
  .main-heading {
    font-size: 2.2rem;
    margin-bottom: 0.8rem;
  }

  .description {
    font-size: 1.1rem;
    margin-bottom: 1.2rem;
  }

  .feature-text {
    font-size: 1.1rem;
  }
}
</style>
